export enum InvoiceSetStatus {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  PAID = "PAID",
  WILL_FAIL = "WILL_FAIL",
  FAILED = "FAILED",
}

export enum InvoiceSetActionType {
  RESUME = "resume",
  PAUSE = "pause",
  CHANGE_RULE_SET = "change rule set",
  TO_COLLECTIONS = "to-collections",
  WRITE_OFF = "write-off",
  CANCEL = "cancel",
}
